import { API_URL } from '../config';
import { safeFetch } from './safeFetch';

export const toNotificationRoute = (url) => {
  if (!url || url === '#') {
    return '/';
  }

  if (/^https?:\/\//i.test(url)) {
    try {
      const parsed = new URL(url);
      if (parsed.hash?.startsWith('#/')) {
        return `${parsed.hash.slice(1)}${parsed.search || ''}`;
      }
      return `${parsed.pathname || '/'}${parsed.search || ''}`;
    } catch {
      return '/';
    }
  }

  if (url.startsWith('/#/')) {
    return url.slice(2) || '/';
  }

  if (url.startsWith('#/')) {
    return url.slice(1) || '/';
  }

  return url.startsWith('/') ? url : `/${url}`;
};

export const toNotificationAppUrl = (url) => {
  const route = toNotificationRoute(url);
  return route === '/' ? '/#/' : `/#${route}`;
};

export const getNotificationOrderId = (url) => {
  const route = toNotificationRoute(url);
  const match = route.match(/^\/order\/(\d+)(?:[/?]|$)/);
  return match ? Number(match[1]) : null;
};

export const canOpenNotificationRoute = async (url) => {
  const route = toNotificationRoute(url);
  const orderId = getNotificationOrderId(route);

  if (!orderId) {
    return { allowed: true, route };
  }

  try {
    const workflow = await safeFetch(`${API_URL}/api/orders/${orderId}/workflow-state`);
    if (workflow?.is_privileged || workflow?.is_current_assignee || workflow?.is_creator) {
      return { allowed: true, route };
    }
    return {
      allowed: false,
      route,
      reason: 'Заказ больше не назначен вам'
    };
  } catch (error) {
    return {
      allowed: false,
      route,
      reason: error.message || 'Не удалось открыть заказ'
    };
  }
};
